export enum FilterPropertyOperator {
  Equals = 'equals',
  NotEquals = 'not-equals',
  Contains = 'contains',
  NotContains = 'not-contains',
  GreaterThan = 'greater-than',
  GreaterThanOrEqual = 'greater-than-or-equal',
  LessThan = 'less-than',
  LessThanOrEqual = 'less-than-or-equal',
  StartsWith = 'starts-with',
  EndsWith = 'ends-with',
  RegExp = 'regexp',
  In = 'in',
  NotIn = 'not-in',
  Empty = 'empty',
  NotEmpty = 'not-empty',
  StartOrEndDateEmpty = 'start-or-end-date-empty',
  StartOrEndDateNotEmpty = 'start-or-end-date-not-empty',
  DateEquals = 'date-equals',// TODO: Remove this and move to equals
  DateNotEquals = 'date-not-equals',
  BetweenDates = 'between-dates',
  OnOrAfterDate = 'on-or-after-date',
  OnOrBeforeDate = 'on-or-before-date',
  AfterDate = 'after-date',
  BeforeDate = 'before-date',
  ArrayIncludes = 'array-includes',
  ArrayNotIncludes = 'array-not-includes',
  ArrayContains = 'array-contains',
  ArrayNotContains = 'array-not-contains',
  FurtherThan = 'further-than',
  NoFurtherThan = 'no-further-than',
  IsRelativeToToday = 'is-relative-to-today',
  ArrayEmpty = 'array-empty',
  ArrayNotEmpty = 'array-not-empty',
  ChecklistCompleted = 'checklist-completed',
  ChecklistNotCompleted = 'checklist-not-completed',
  Truthy = 'truthy',
  Falsy = 'falsy',
}
